import React from 'react';




import Header from './Header';
import Footer from './Footer';
import Faq from './faq';
import FooterBanner from './FooterBanner';

function PrimeFaq() {
return (
<React.StrictMode>
   <Header/>
   
   <section id="faq" className="bg-gray pb-0 pt-5">
        <div className="container mt-lg-5 ">
          <div className="row">
            <div className="col-lg-10 mx-auto text-center">
              <h2 className="section-title mb-sm-4 mt-0">Frequently asked questions</h2>
              <p className="text-muted mb-0 mb-sm-3">This topic lists the different frequently asked questions (FAQ) on different areas in TallyPrime and the responses to each of the questions.</p>
            </div>
          </div>
        </div>
      </section>
   <Faq/>
   <FooterBanner/>
    <Footer/>
</React.StrictMode>
)
}
export default PrimeFaq;